import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { requestPasswordRecovery, resetPassword } from '../authService';
import { CelestialShell, SystemFooter } from './ui/CelestialShell';

export default function PasswordRecovery() {
  const location = useLocation();
  const token = new URLSearchParams(location.search).get('token') || '';
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setBusy(true); setMessage('');
    try {
      if (token) {
        await resetPassword(token, password);
        setMessage('Password changed. You can sign in with your new password.');
      } else {
        await requestPasswordRecovery(email);
        setMessage('If an eligible account exists, a recovery link will be sent.');
      }
    } catch (error) {
      setMessage(token ? 'This recovery link is invalid or has expired.' : 'Recovery is temporarily unavailable.');
    } finally { setBusy(false); }
  };

  return (
    <CelestialShell>
      <div className="br-container">
        <main className="br-auth-layout br-auth-layout--recovery">
          <section className="br-auth-story"><p className="br-eyebrow">Account recovery</p><h1 className="br-page-title">Return securely.</h1><p className="br-lead">Recovery links are private, time-limited, and valid for one use.</p></section>
          <section className="br-auth-card br-glass">
            <header className="br-auth-card__header"><p className="br-eyebrow">Security</p><h2 className="br-auth-card__title">{token ? 'Choose a new password.' : 'Recover your account.'}</h2></header>
            <form onSubmit={submit} className="br-auth-form">
              {token ? <div className="br-field"><label htmlFor="br-recovery-password">New password</label><input id="br-recovery-password" className="br-input" type="password" minLength="12" autoComplete="new-password" value={password} onChange={(event) => setPassword(event.target.value)} required /></div>
                : <div className="br-field"><label htmlFor="br-recovery-email">Verified email</label><input id="br-recovery-email" className="br-input" type="email" autoComplete="email" value={email} onChange={(event) => setEmail(event.target.value)} required /></div>}
              {message && <p className="br-status" role="status">{message}</p>}
              <button className="br-button br-button--primary" type="submit" disabled={busy || (token ? password.length < 12 : !email)}>{busy ? 'Working...' : token ? 'Update password' : 'Send recovery link'}</button>
              <div className="br-auth-links"><Link to="/login">Return to sign in</Link></div>
            </form>
          </section>
        </main>
        <SystemFooter />
      </div>
    </CelestialShell>
  );
}
